import { getSitecoreConfig } from "~/temp/get-config";
export type { SitecoreConfig } from "~/temp/get-config";

const config = getSitecoreConfig(import.meta.env || {});
const isServer = typeof window === "undefined";

if (!isServer) {
	config.sitecoreApiHost = ""; // client side we want it to use the existing hostname
}

export default config;